import React, { useRef } from "react";
import EmailEditor from "react-email-editor";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { MERGE_TAGS } from "@/lib/emailDesign";

const PROJECT_ID = process.env.REACT_APP_UNLAYER_PROJECT_ID ? Number(process.env.REACT_APP_UNLAYER_PROJECT_ID) : undefined;

export default function EmailBuilder({ design, onLoaded, onChange, editorRef, minHeight = 640 }) {
  const timer = useRef(null);
  const onReady = (unlayer) => {
    editorRef.current = unlayer;
    unlayer.registerCallback("image", (file, done) => {
      const fd = new FormData();
      fd.append("file", file.attachments[0]);
      api.post("/email-marketing/assets", fd, { headers: { "Content-Type": "multipart/form-data" } })
        .then(({ data }) => done({ progress: 100, url: data.url }))
        .catch((e) => { toast.error(e?.response?.data?.detail || "Image upload failed"); done({ progress: 0 }); });
    });
    if (design) unlayer.loadDesign(design);
    unlayer.addEventListener("design:updated", () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => unlayer.exportHtml((d) => onChange?.(d.design, d.html)), 4000);
    });
    onLoaded?.(unlayer);
  };
  return (
    <div className="border border-slate-200 rounded-xl overflow-hidden bg-white" data-testid="unlayer-builder">
      <EmailEditor onReady={onReady} minHeight={minHeight}
        options={{ ...(PROJECT_ID ? { projectId: PROJECT_ID } : {}), displayMode: "email", mergeTags: MERGE_TAGS, appearance: { theme: "modern_light" },
          features: { preview: true, imageEditor: true, undoRedo: true } }} />
    </div>
  );
}

export const exportDesign = (editor) => new Promise((resolve) => editor.exportHtml((d) => resolve(d)));

export function showPreview(editor, device) {
  try { editor.showPreview({ device }); } catch { editor.showPreview(device); }
}
